import React, { FC } from "react";
import AssetChange from "../components/AssetChange";
import AssetValue from "../components/AssetValue";
import View from "../components/View";
import WorthLine from "../components/charts/WorthLine";
import PortfolioLine from "../components/charts/PortfolioLine";
import DailyLine from "../components/charts/DailyLine";
import DailyBar from "../components/charts/DailyBar";
import Dropdown from "../components/Dropdown";
import { ReactComponent as VertDivider } from "../assets/svg/vert-divider.svg";
import { ReactComponent as Divider } from "../assets/svg/divider.svg";

const buttonStyles = "hover:text-green-600";

const Performance: FC = () => {
  return (
    <View>
      <>
        <div className="w-full h-[12rem] flex flex-row items-center">
          <AssetValue />
          <VertDivider className="h-[70%] fill-green-700" />
          <AssetChange />
        </div>

        <div
          id="performance-wrapper"
          className="w-[80%] h-auto p-4 mb-4 flex flex-col"
        >
            <Divider className="mb-5" />
          <div className="flex flex-row w-full items-center justify-end text-white pb-2">
            <p className="mr-4">Zoom:</p>
            {/* <Dropdown /> */}
            {/* <button className={buttonStyles}>1 Day</button>
            <button className={buttonStyles}>1 Week</button>
            <button className={buttonStyles}>1 Month</button>
            <button className={buttonStyles}>6 Months</button>
            <button className={buttonStyles}>1 Year</button>
            <button className={buttonStyles}>All Time</button> */}
          </div>
          <div className="h-[20rem] w-full flex rounded-md bg-zinc-700 shadow-xl items-center justify-center p-3 mb-6">
            <WorthLine />
          </div>
          <div className="h-[20rem] flex rounded-md bg-zinc-700 shadow-xl items-center justify-center p-3 mb-6">
            <PortfolioLine />
          </div>
          <div id="profit-loss-wrapper" className="w-full h-[20rem] flex md:flex-row xs:flex-col">
           <div id="daily-bar-wrapper" className="xs:w-full md:w-[48%] h-full bg-zinc-700 mb-4 md:mr-4 rounded-md">
                <DailyBar />
           </div>
           <div id="cumulative-line-wrapper" className="xs:w-full md:w-[48%] h-full bg-zinc-700 mb-4 md:ml-4 rounded-md">
                <DailyLine />
           </div>
          </div>
        </div>
      </>
    </View>
  );
};

export default Performance;
